import { NugetType, } from '@models';
import { CommonNugetService, FileDownloadService, } from '@services';
var NugetChangelogListComponent = /** @class */ (function () {
    function NugetChangelogListComponent(_commonNugetService, _downloadService) {
        this._commonNugetService = _commonNugetService;
        this._downloadService = _downloadService;
    }
    Object.defineProperty(NugetChangelogListComponent.prototype, "isDownloadEnabled", {
        get: function () {
            return this._commonNugetService.isNugetDownloadEnabled(this.type);
        },
        enumerable: true,
        configurable: true
    });
    NugetChangelogListComponent.prototype.downloadLink = function (entry) {
        return this.nugetService.downloadLink(entry);
    };
    NugetChangelogListComponent.prototype.downloadPackage = function (event, entry) {
        event.preventDefault();
        this._downloadService.download(this.nugetService.downloadLink(entry));
    };
    return NugetChangelogListComponent;
}());
export { NugetChangelogListComponent };
